import { useState, useEffect, useLayoutEffect, CSSProperties, useRef } from "react";
import { getOrgAlarmTypes } from "../../../api/dashboard";
import ChartCanvas from './ChartCanvas'
import { EChartsInitOpts } from "echarts";
import { Title, Loading } from "../Layouts";

export default function AlarmTypesPie(p: { proejct?: Project, style: CSSProperties }) {
    const [options, setOptions] = useState<EChartsInitOpts>();
    const titleRef = useRef<HTMLDivElement>(null);
    const [canvasHeight, setCanvasHeight] = useState((p.style.height as number) - 27.5);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!p.proejct) return;
        const map: any = {
            '设备总数': p.proejct.deviceOverview.deviceTotalCount,
            '在线空开': p.proejct.deviceOverview.onlineSwitchCount,
            '离线空开': p.proejct.deviceOverview.offlineSwitchCount,
            '告警设备': p.proejct.deviceOverview.alarmDeviceCount,
        }
        const option = {
            backgroundColor: 'rgb(9, 53, 99)',
            tooltip: {
                trigger: 'item'
            },
            legend: {
                show: true,
                formatter: (name: string) => {
        
                    return `${name}(${map[name]})`
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: [0, 40],
                    center: ['50%', '60%'],
                    // roseType: 'area',
                    itemStyle: {
                        borderRadius: 0
                    },
                    data: [
                        {
                            name: '设备总数',
                            value:  p.proejct.deviceOverview.deviceTotalCount,
                        },
                        {
                            name: '在线空开',
                            value:  p.proejct.deviceOverview.onlineSwitchCount,
                        },
                        {
                            name: '离线空开',
                            value:  p.proejct.deviceOverview.offlineSwitchCount,
                        },
                        {
                            name: '告警设备',
                            value:  p.proejct.deviceOverview.alarmDeviceCount,
                        },
                    ]
                }
            ]
        };
        setOptions(option as any)

    }, [p.proejct]);
    useLayoutEffect(() => {
        if (titleRef.current) {
            setCanvasHeight((p.style.height as number) - titleRef.current.clientHeight)
        }
    }, [p.style.height])
    return <div style={{ ...p.style }}>
        <Title ref={titleRef}>设备信息汇总</Title>
        {
            loading ?
                <div style={{
                    width: p.style.width, height: canvasHeight,
                    background: 'rgb(9, 53, 99)'
                }}>
                    <Loading />
                </div> :
                <ChartCanvas options={options} styles={{
                    width: p.style.width, height: canvasHeight,
                }} />
        }
    </div>
}